module.exports = __webpack_public_path__ + "media/components/src/assets/images/blogs/1-1ba2064608bcd347a95ac09a544b27c9.jpg";